module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1039-09fe859c600641f3ec6f55cb2b56eea0.png";